import { AxiosError } from "axios";

import { ADMIN_API_ENDPOINTS } from "@/config/apiEndpoints/adminUrls";
import { handleApiError } from "@/lib/utils";
import { IScholar } from "@/types/page";
import adminAxios from "@/lib/axios";

export async function createScholar(payload: Partial<IScholar>) {
  try {
    const response = await adminAxios.post(
      ADMIN_API_ENDPOINTS.SCHOLAR.CREATE,
      payload
    );

    return response?.status === 201 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}

export async function updateScholar(id: number, payload: Partial<IScholar>) {
  try {
    const response = await adminAxios.put(
      ADMIN_API_ENDPOINTS.SCHOLAR.UPDATE(id),
      payload
    );

    return response?.status === 200 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}

// Keep the generic functions for backward compatibility if needed
export const createSection = createScholar;
export const updateSection = updateScholar;